import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab
} from '@mui/material';

const Terms = () => {
  const [language, setLanguage] = useState('cn'); // 'cn' for Chinese, 'en' for English
  
  const handleLanguageChange = (event, newValue) => {
    setLanguage(newValue);
  };
  
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom align="center">
          服务条款 / Terms of Service
        </Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
          <Tabs value={language} onChange={handleLanguageChange} centered>
            <Tab label="中文" value="cn" />
            <Tab label="English" value="en" />
          </Tabs>
        </Box>
        
        {language === 'cn' ? (
          <>
            <Typography variant="body1" paragraph>
              最后更新日期：2024年3月21日
            </Typography>
            
            <Typography variant="body1" paragraph>
              欢迎访问Destiny Crystal网站（以下简称"本网站"）。本网站由Destiny Crystal（以下简称"我们"或"本公司"）提供。通过访问和使用本网站，您同意遵守本服务条款（以下简称"条款"）。如果您不同意这些条款，请勿使用本网站。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              1. 使用条款
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              本网站提供的服务包括但不限于：水晶手串、摆件等产品销售、AI算命服务和专业命理师咨询预约服务。用户须知晓：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="账户责任" 
                  secondary="您对使用您的账户所进行的所有活动负责，包括保持密码安全。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="禁止行为" 
                  secondary="您不得以任何方式干扰网站功能或试图访问非公开区域，不得进行任何可能损害网站的行为。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="服务变更" 
                  secondary="我们保留随时修改、暂停或终止网站及其服务的权利，恕不另行通知。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              2. 产品与服务
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              关于我们的产品和服务，您需要了解：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="产品描述" 
                  secondary="我们努力确保网站上的产品描述、图片和价格准确无误，但不保证绝对无误。如有错误，我们保留纠正的权利。所有产品价格均以新加坡元(SGD)列示。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="库存情况" 
                  secondary="所有水晶产品均为精选天然石材，每一件都是独特的，并视库存情况而定。如果产品缺货，我们会通知您并提供退款或替代选择。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="算命服务免责声明" 
                  secondary="本网站提供的AI算命和专业命理师咨询服务仅供娱乐和参考，不构成专业建议或预测。我们不保证算命结果的准确性，也不对您基于这些结果做出的决定负责。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="预约服务" 
                  secondary="命理师预约服务受到额外条款的约束，包括取消政策和预约规则，详见预约页面。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              3. 订单和支付
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              关于订单和支付流程：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="订单确认" 
                  secondary="当您下单时，您将收到一封订单确认电子邮件。这表示我们已收到您的订单，但不代表订单已被接受。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="订单接受" 
                  secondary="当我们发出发货确认时，订单才被视为已接受。我们保留拒绝任何订单的权利。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="支付方式" 
                  secondary="我们接受网站上列出的支付方式，包括信用卡、PayPal等。所有支付信息均通过安全加密处理。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="价格和税费" 
                  secondary="所有价格均以新加坡元(SGD)列示，不包含税费和运费，这些将在结账时单独计算。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              4. 配送政策
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们的配送政策如下：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="配送时间" 
                  secondary="我们会在订单确认后的1-3个工作日内发货。配送时间取决于您的位置，新加坡本地通常为1-2个工作日，国际配送约为7-14个工作日。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="配送区域" 
                  secondary="我们主要向新加坡本地客户提供配送服务。国际配送可能需要额外时间和费用，请联系客服了解详情。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="配送风险" 
                  secondary="产品的所有权和损失风险在产品交付给您时转移给您。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="配送问题" 
                  secondary="如配送过程中出现问题，请联系我们的客服团队。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              5. 退货与退款
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们的退货和退款政策如下：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="退货期限" 
                  secondary="自收到商品之日起7天内，您可以申请退货。商品必须保持未使用、未损坏的原始状态，并包含所有原包装和标签。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="退货流程" 
                  secondary="退货前请联系我们的客服获取退货授权和具体指南。未经授权的退货可能不被接受。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="退款处理" 
                  secondary="一旦退货被接受，退款将在10个工作日内处理，并通过原支付方式返还。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="不可退货商品" 
                  secondary="定制商品、已使用或已开封的水晶产品不可退货。所有数字服务（如AI算命报告）和已完成的命理师咨询一旦提供不可退款。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              6. 知识产权
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              关于知识产权：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="网站内容" 
                  secondary="本网站的所有内容，包括但不限于文本、图像、徽标、按钮图标、图片、音频剪辑、数字下载、数据编译和软件，均为本公司或其内容提供商的财产，受国际版权法保护。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="商标" 
                  secondary="Destiny Crystal和所有相关徽标、产品和服务名称均为本公司的商标。未经我们明确书面许可，不得以任何方式使用这些商标。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="授权使用" 
                  secondary="我们授予您访问和使用本网站的有限许可，仅用于个人、非商业目的。未经我们事先书面同意，不得复制、修改、创建衍生作品、公开展示、表演、再版、下载、存储或传输本网站的任何内容。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              7. 免责声明
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              重要免责声明：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="服务提供基础" 
                  secondary='本网站及其内容和服务"按原样"和"按可用性"提供，不作任何形式的保证，无论是明示的还是暗示的。' 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="算命服务声明" 
                  secondary="我们的AI算命和专业命理师咨询服务仅供娱乐和参考之用，不应被视为专业建议或预测。我们不对任何基于这些服务所做决定的结果负责。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="水晶能量声明" 
                  secondary="我们网站上销售的水晶产品被认为具有特定能量属性，但这些描述基于传统信仰和个人体验，不构成医疗或治疗声明。我们的产品不能替代专业医疗建议或治疗。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="责任限制" 
                  secondary="在法律允许的最大范围内，本公司、其管理人员、董事、员工、代理商或供应商对因使用或无法使用本网站、服务或内容而导致的任何直接、间接、特殊、惩罚性、附带或后果性损害不承担责任。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              8. 争议解决
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              如果发生争议：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="适用法律" 
                  secondary="本条款受新加坡法律管辖，不考虑法律冲突原则。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="争议解决方式" 
                  secondary="因本条款或您使用本网站而产生的任何争议，应首先尝试通过友好协商解决。如协商不成，应提交至新加坡国际仲裁中心(SIAC)根据其当时有效的规则进行仲裁。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="仲裁地点" 
                  secondary="任何仲裁程序应在新加坡进行，仲裁语言为英语或中文。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              9. 条款变更
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们可能会不时修改本条款。当我们进行重大变更时，我们将在网站上发布更新后的条款，并在必要时通过电子邮件通知您。您继续使用本网站表示您接受这些更改。我们建议您定期查看本页面以了解最新的条款。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              10. 联系我们
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              如果您对本服务条款有任何疑问或建议，请通过以下方式联系我们：
            </Typography>
            <Box sx={{ ml: 3 }}>
              <Typography variant="body1">电子邮件：dylan@martha-trade.com</Typography>
              <Typography variant="body1">地址：10 MARINA BOULEVARD #39 MARINA BAY FINANCIAL CENTRE SINGAPORE (018983)</Typography>
              <Typography variant="body1">电话：+65 91761341</Typography>
            </Box>
            
            <Box sx={{ mt: 6, p: 3, bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                通过使用我们的网站和服务，您确认您已阅读、理解并同意受本服务条款的约束。
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="body1" paragraph>
              Last Updated: March 21, 2024
            </Typography>
            
            <Typography variant="body1" paragraph>
              Welcome to the Destiny Crystal website (hereinafter referred to as "the Website"). This Website is provided by Destiny Crystal (hereinafter referred to as "we" or "the Company"). By accessing and using this Website, you agree to comply with these Terms of Service (hereinafter referred to as "Terms"). If you do not agree to these Terms, please do not use this Website.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              1. Terms of Use
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              The services provided by this Website include but are not limited to: sales of crystal bracelets and ornaments, AI fortune-telling services, and professional fortune-teller consultation booking services. Users should be aware of:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Account Responsibility" 
                  secondary="You are responsible for all activities conducted using your account, including maintaining password security." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Prohibited Behavior" 
                  secondary="You must not interfere with the Website's functionality or attempt to access non-public areas, nor engage in any conduct that may harm the Website." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Service Changes" 
                  secondary="We reserve the right to modify, suspend, or terminate the Website and its services at any time without prior notice." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              2. Products and Services
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Regarding our products and services, you need to understand:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Product Description" 
                  secondary="We strive to ensure that product descriptions, images, and prices on the Website are accurate, but we do not guarantee absolute accuracy. If there are errors, we reserve the right to correct them. All product prices are listed in Singapore Dollars (SGD)." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Inventory Status" 
                  secondary="All crystal products are carefully selected natural stones, each one is unique, and subject to availability. If a product is out of stock, we will notify you and provide a refund or alternative options." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Fortune-Telling Service Disclaimer" 
                  secondary="AI fortune-telling and professional fortune-teller consultation services provided by this Website are for entertainment and reference only and do not constitute professional advice or predictions. We do not guarantee the accuracy of fortune-telling results, nor are we responsible for decisions you make based on these results." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Booking Services" 
                  secondary="Fortune-teller booking services are subject to additional terms, including cancellation policies and booking rules, as detailed on the booking page." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              3. Orders and Payment
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Regarding order and payment processes:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Order Confirmation" 
                  secondary="When you place an order, you will receive an order confirmation email. This indicates that we have received your order, but does not mean the order has been accepted." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Order Acceptance" 
                  secondary="An order is considered accepted only when we issue a shipping confirmation. We reserve the right to refuse any order." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Payment Methods" 
                  secondary="We accept the payment methods listed on the Website, including credit cards, PayPal, etc. All payment information is processed securely and encrypted." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Prices and Taxes" 
                  secondary="All prices are listed in Singapore Dollars (SGD) and do not include taxes and shipping fees, which will be calculated separately at checkout." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              4. Shipping Policy
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Our shipping policy is as follows:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Shipping Time" 
                  secondary="We will ship within 1-3 business days after order confirmation. Delivery time depends on your location, typically 1-2 business days for local Singapore deliveries, and approximately 7-14 business days for international shipping." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Shipping Area" 
                  secondary="We primarily provide shipping services to customers in Singapore. International shipping may require additional time and fees, please contact customer service for details." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Shipping Risk" 
                  secondary="Ownership and risk of loss of the products transfer to you upon delivery." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Shipping Issues" 
                  secondary="If there are any issues during the shipping process, please contact our customer service team." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              5. Returns and Refunds
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Our return and refund policy is as follows:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Return Period" 
                  secondary="You may request a return within 7 days of receiving the product. The product must be in its original unused, undamaged condition and include all original packaging and tags." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Return Process" 
                  secondary="Please contact our customer service for return authorization and specific guidelines before returning. Unauthorized returns may not be accepted." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Refund Processing" 
                  secondary="Once a return is accepted, refunds will be processed within 10 business days and returned through the original payment method." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Non-Returnable Items" 
                  secondary="Custom products, used or opened crystal products cannot be returned. All digital services (such as AI fortune-telling reports) and completed fortune-teller consultations are non-refundable once provided." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              6. Intellectual Property
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Regarding intellectual property:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Website Content" 
                  secondary="All content on this Website, including but not limited to text, images, logos, button icons, pictures, audio clips, digital downloads, data compilations, and software, are the property of the Company or its content providers and are protected by international copyright laws." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Trademarks" 
                  secondary="Destiny Crystal and all related logos, product and service names are trademarks of the Company. These trademarks may not be used in any manner without our express written permission." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Authorized Use" 
                  secondary="We grant you a limited license to access and use this Website for personal, non-commercial purposes only. Without our prior written consent, you may not copy, modify, create derivative works, publicly display, perform, republish, download, store, or transmit any content on this Website." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              7. Disclaimer
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Important disclaimers:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Service Provision Basis" 
                  secondary='This Website and its content and services are provided "as is" and "as available" without any warranties of any kind, whether express or implied.' 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Fortune-Telling Service Statement" 
                  secondary="Our AI fortune-telling and professional fortune-teller consultation services are for entertainment and reference purposes only and should not be viewed as professional advice or predictions. We are not responsible for the outcomes of any decisions made based on these services." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Crystal Energy Statement" 
                  secondary="The crystal products sold on our Website are believed to have specific energy properties, but these descriptions are based on traditional beliefs and personal experiences and do not constitute medical or therapeutic claims. Our products cannot replace professional medical advice or treatment." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Limitation of Liability" 
                  secondary="To the maximum extent permitted by law, the Company, its officers, directors, employees, agents, or suppliers shall not be liable for any direct, indirect, special, punitive, incidental, or consequential damages arising from the use or inability to use this Website, services, or content." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              8. Dispute Resolution
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              In case of disputes:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Applicable Law" 
                  secondary="These Terms are governed by the laws of Singapore, without regard to conflict of law principles." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Dispute Resolution Method" 
                  secondary="Any dispute arising from these Terms or your use of this Website should first be attempted to be resolved through friendly negotiation. If negotiation fails, the dispute shall be submitted to the Singapore International Arbitration Centre (SIAC) for arbitration in accordance with its then-effective rules." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Arbitration Venue" 
                  secondary="Any arbitration proceedings shall be conducted in Singapore, with English or Chinese as the arbitration language." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              9. Terms Changes
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We may modify these Terms from time to time. When we make significant changes, we will post the updated Terms on the Website and notify you via email when necessary. Your continued use of this Website indicates your acceptance of these changes. We recommend that you review this page regularly to stay informed of the latest Terms.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              10. Contact Us
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              If you have any questions or suggestions regarding these Terms of Service, please contact us through the following methods:
            </Typography>
            <Box sx={{ ml: 3 }}>
              <Typography variant="body1">Email: dylan@martha-trade.com</Typography>
              <Typography variant="body1">Address: 10 MARINA BOULEVARD #39 MARINA BAY FINANCIAL CENTRE SINGAPORE (018983)</Typography>
              <Typography variant="body1">Phone: +65 91761341</Typography>
            </Box>
            
            <Box sx={{ mt: 6, p: 3, bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                By using our Website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
              </Typography>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Terms;